import SlideShow from "../Reusable Elements/SlideShow";
import { constructionImages } from "../../data/slideShowData";

const Construction = () => {
    return (
        <div className="flex w-screen items-center justify-between sm:flex-row flex-col pt-7 sm:pb-7">
            <div className="flex flex-col sm:pl-10 sm:pr-14 sm:w-[60vw] px-2">
                <div className="font-poppins font-extralight text-4xl text-center text-primary-gold sm:pb-0 pb-1">
                    Construction
                </div>
                <div className="font-poppins text-lg font-extralight text-center mt-1 text-primary-blue px-10 sm:px-0 sm:pb-0 pb-8">
                    Our company combines global construction practices with
                    ongoing skill development, empowering our workforce with
                    tested and trusted methods and techniques. <br></br>
                    <br></br>Delivering high-standard, environmentally
                    responsible projects, Sultana Homes promotes sustainability
                    and long-lasting results.
                </div>
            </div>
            <div>
                <SlideShow side={"right"} images={constructionImages} />
            </div>
        </div>
    );
};

export default Construction;
